import { eventListMap, eventsWhiteList, pushEvent } from "../../utils/gtmutils";
import * as actionTypes from "./actionTypes";

const initialState = {
  twitter: {
    user: null,
    error: null,
    loading: false,
  },
  deso: {
    user: null,
    error: null,
    loading: false,
  },
  facebook: {
    user: null,
    error: null,
    loading: false,
  },
  instgram: {
    user: null,
    error: null,
    loading: false,
  },
  wordpress: {
    user: null,
    error: null,
    loading: false,
  },
  tweets: [],
  modalVisible: false,
  loading: false,
  error: null,
  dataSubmited: false,
  partialUpload: false,
  check: false,
  selectAllPostState: false,
  isDesoBalanceModal: false,
  colorShow: false,
  selectButton: "",
  cart: [],
  showIframe: false,
  approve: false,
  realTimeSyncData: {},
  realTimeModal: false,
  realTimeLoading: false,
  userMetaData: {},
  desoUserProfileData: {},
  updateProfileData: {},
  followFormData: {},
  updateProfileState: {
    loading: false,
    step: null,
    modal: false,
  },
};

const setDesoUserProfileData = (state, action) => {
  return {
    ...state,
    desoUserProfileData: action.value,
  };
};

const setUpdateProfileState = (state, action) => {
  return {
    ...state,
    updateProfileState: action.value,
  };
};

const setRealTimeModal = (state, action) => {
  return {
    ...state,
    realTimeModal: action.realTimeModal,
  };
};
const setRealTimeLoading = (state, action) => {
  return {
    ...state,
    realTimeLoading: action.realTimeLoading,
  };
};

const setRealTimeSync = (state, action) => {
  return {
    ...state,
    realTimeSyncData: action.payload,
  };
};
const setUserMetaData = (state, action) => {
  return {
    ...state,
    userMetaData: action.payload,
  };
};

const handleApprove = (state, action) => {
  return {
    ...state,
    approve: action.approve,
  };
};

const twitterLoginStart = (state, action) => {
  return {
    ...state,
    twitter: {
      user: null,
      loading: true,
      error: null,
      realodUserInfo: null,
    },
  };
};
const twitterLoginSuccess = (state, action) => {
  return {
    ...state,
    twitter: {
      user: action.data,
      loading: false,
      error: null,
    },
  };
};
const twitterLoginFail = (state, action) => {
  return {
    ...state,
    twitter: {
      user: null,
      realodUserInfo: null,
      loading: false,
      error: action.data,
    },
  };
};

const twitterSignOutStart = (state, action) => {
  return {
    ...state,
    twitter: {
      loading: true,
      error: null,
    },
  };
};
const twitterSignOutSuccess = (state, action) => {
  return {
    ...state,
    twitter: {
      user: null,
      loading: false,
      error: null,
    },
  };
};
const facebookLoginStart = (state, action) => {
  return {
    ...state,
    facebook: {
      user: null,
      loading: true,
      error: null,
    },
  };
};
const facebookLoginSuccess = (state, action) => {
  return {
    ...state,
    facebook: {
      user: action.user,
      loading: false,
      error: null,
    },
  };
};
const facebookLoginFailure = (state, action) => {
  return {
    ...state,
    facebook: {
      user: null,
      loading: false,
      error: action.error,
    },
  };
};

const wordpressLoginStart = (state, action) => {
  return {
    ...state,
    wordpress: {
      user: null,
      loading: true,
      error: null,
    },
  };
};
const wordpressLoginSuccess = (state, action) => {
  return {
    ...state,
    wordpress: {
      user: action.user,
      loading: false,
      error: null,
    },
  };
};
const wordpressLoginFailure = (state, action) => {
  return {
    ...state,
    wordpress: {
      user: null,
      loading: false,
      error: action.error,
    },
  };
};

const twitterSignOutFail = (state, action) => {
  return {
    ...state,
    twitter: {
      user: null,
      loading: false,
      error: action.data,
    },
  };
};

const desoLoginSuccess = (state, action) => {
  return {
    ...state,
    deso: {
      user: action.data,
      loading: false,
      error: null,
    },
    dataSubmited: action?.data === null ? false : state?.dataSubmited,
  };
};

const setSelectAllPostState = (state, action) => ({
  ...state,
  selectAllPostState: action.data,
});

const setCheck = (state, action) => ({
  ...state,
  check: action.data,
});

const setCart = (state, action) => ({
  ...state,
  cart: action.cart,
});
const setShowIFrame = (state, action) => ({
  ...state,
  showIframe: action.showIframe,
});

const setIsDesoBalanceModal = (state, action) => ({
  ...state,
  isDesoBalanceModal: action.data,
});

const setColorShow = (state, action) => ({
  ...state,
  colorShow: action.data,
});

const setModalVisible = (state, action) => ({
  ...state,
  modalVisible: action.data,
});

const fetchTwitterTimelineStart = (state, action) => {
  return {
    ...state,
    loading: true,
  };
};
const fetchTwitterTimelineSuccess = (state, action) => {
  return {
    ...state,
    tweets: action.data,
    loading: false,
  };
};
const fetchTwitterTimelineFail = (state, action) => {
  return {
    ...state,
    loading: false,
    error: action.error,
  };
};
const postDataStart = (state, action) => {
  return {
    ...state,
    loading: true,
  };
};
const postDataSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    dataSubmited: true,
  };
};
const postDataFail = (state, action) => {
  return {
    ...state,
    loading: false,
  };
};
const postDataPartialSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    dataSubmited: true,
    partialUpload: true,
  };
};

const setProfileData = (state, action) => {
  return {
    ...state,
    updateProfileData: action.payload,
  };
};
const setFollowFormData = (state, action) => {
  return {
    ...state,
    followFormData: action.payload,
  };
};

const reducer = (state = initialState, action) => {
  if (eventsWhiteList.includes(action.type)) {
    pushEvent(eventListMap[action.type], state);
  }
  switch (action.type) {
    case actionTypes.TWITTER_LOGIN_START:
      return twitterLoginStart(state, action);
    case actionTypes.TWITTER_LOGIN_SUCCESS:
      return twitterLoginSuccess(state, action);
    case actionTypes.TWITTER_LOGIN_FAIL:
      return twitterLoginFail(state, action);
    case actionTypes.TWITTER_SIGN_OUT_START:
      return twitterSignOutStart(state, action);
    case actionTypes.TWITTER_SIGN_OUT_SUCCESS:
      return twitterSignOutSuccess(state, action);
    case actionTypes.FACEBOOK_LOGIN_START:
      return facebookLoginStart(state, action);
    case actionTypes.FACEBOOK_LOGIN_SUCCESS:
      return facebookLoginSuccess(state, action);
    case actionTypes.FACEBOOK_LOGIN_FAIL:
      return facebookLoginFailure(state, action);
    case actionTypes.TWITTER_SIGN_OUT_FAIL:
      return twitterSignOutFail(state, action);
    case actionTypes.DESO_LOGIN_SUCCESS:
      return desoLoginSuccess(state, action);
    case actionTypes.SET_MODAL_VISIBLE:
      return setModalVisible(state, action);
    case actionTypes.REAL_TIME_SYNC_DATA:
      return setRealTimeSync(state, action);
    case actionTypes.SET_COLOR_SHOW:
      return setColorShow(state, action);
    case actionTypes.SET_CHECK:
      return setCheck(state, action);
    case actionTypes.CART:
      return setCart(state, action);
    case actionTypes.SELECT_ALL_POST:
      return setSelectAllPostState(state, action);
    case actionTypes.SET_SHOW_IFRAME:
      return setShowIFrame(state, action);
    case actionTypes.HANDLE_APPROVE:
      return handleApprove(state, action);
    case actionTypes.REAL_TIME_MODAL:
      return setRealTimeModal(state, action);
    case actionTypes.REAL_TIME_LOADING:
      return setRealTimeLoading(state, action);
    case actionTypes.SET_IS_DESO_BALANCE_MODAL:
      return setIsDesoBalanceModal(state, action);
    case actionTypes.FETCH_TWITTER_TIMELINE_START:
      return fetchTwitterTimelineStart(state, action);
    case actionTypes.FETCH_TWITTER_TIMELINE_SUCCESS:
      return fetchTwitterTimelineSuccess(state, action);
    case actionTypes.FETCH_TWITTER_TIMELINE_FAIL:
      return fetchTwitterTimelineFail(state, action);
    case actionTypes.POST_DATA_START:
      return postDataStart(state, action);
    case actionTypes.POST_DATA_SUCCESS:
      return postDataSuccess(state, action);
    case actionTypes.POST_DATA_PARTIAL_SUCCESS:
      return postDataPartialSuccess(state, action);
    case actionTypes.POST_DATA_FAIL:
      return postDataFail(state, action);
    case actionTypes.SET_USER_META_DATA:
      return setUserMetaData(state, action);
    case actionTypes.UPDATE_USER_PROFILE_DATA:
      return setProfileData(state, action);
    case actionTypes.FOLLOW_FORM_DATA:
      return setFollowFormData(state, action);
    case actionTypes.UPDATE_PROFILE_STATE:
      return setUpdateProfileState(state, action);
    case actionTypes.DESO_USER_PROFILE_DATA:
      return setDesoUserProfileData(state, action);
    case actionTypes.WORDPRESS_LOGIN_START:
      return wordpressLoginStart(state, action);
    case actionTypes.WORDPREES_LOGIN_SUCCESS:
      return wordpressLoginSuccess(state, action);
    case actionTypes.WORDPRESS_LOGIN_FAIL:
      return wordpressLoginFailure(state, action);
    default:
      return state;
  }
};

export default reducer;
